/**
 * Capabilities / features de la empresa — gating de UI.
 *
 * Las features activas llegan en la sesión (`company.features`, desde GET /auth/me,
 * resueltas por TB\Billing\Capabilities = plan ∪ add-ons). El backend igual
 * re-valida lo sensible; esto sólo decide qué mostrar/ocultar.
 */
import { useAuth } from './auth/AuthProvider';

/** Clave de la feature "Agenda de audiencias" (eventos con hora/lugar). */
export const FEATURE_CALENDAR_AGENDA = 'calendar_agenda';

/** ¿La empresa de la sesión tiene activa la feature dada? */
export function useHasFeature(key: string): boolean {
  const { company } = useAuth();
  return company?.features?.includes(key) ?? false;
}
